import { render, staticRenderFns } from "./ba.vue?vue&type=template&id=367f2bf6&"
import script from "./ba.vue?vue&type=script&lang=js&"
export * from "./ba.vue?vue&type=script&lang=js&"
import style0 from "./ba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports